import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export function useAuth() {
  const { user, loading, initialized, initialize, signIn, signUp, signOut } =
    useAuthStore()

  useEffect(() => {
    if (!initialized) {
      initialize()
    }
  }, [initialized, initialize])

  return {
    user,
    loading,
    initialized,
    isAuthenticated: !!user,
    signIn,
    signUp,
    signOut,
  }
}

// Hook that redirects to login if not authenticated
export function useRequireAuth(redirectTo = '/login') {
  const { isAuthenticated, loading, initialized } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (initialized && !loading && !isAuthenticated) {
      navigate(redirectTo, { replace: true })
    }
  }, [isAuthenticated, loading, initialized, navigate, redirectTo])

  return { isAuthenticated, loading: loading || !initialized }
}
